const UseMixin =
  /**
   * @param {object} target
   * @param {object} mixin
   */
  (target, mixin) => mixin(target);

export const UseMixins =
  /**
   * @param {object} target
   * @param {array} mixins
   */
  (target, mixins) => mixins.reduce((t, mixin) => UseMixin(t, mixin), target);
